import { UseDebounceType } from "@website/hooks/debounce/debounce.types";
import isEqual from "lodash-es/isEqual";
import { useEffect, useRef, useState } from "react";

export const useDebounce: UseDebounceType = (value, timeout) => {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(
      () =>
        setDebouncedValue((state) => (isEqual(value, state) ? state : value)),
      timeout ?? 500
    );

    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    };
  }, [value]);

  return debouncedValue;
};
